import { Link } from '@tanstack/react-router';
import type { QcHoldView } from '@wodi/shared';
import { Notice } from '@wodi/ui';

import { formatInstant } from '../patients/format.ts';
import styles from './lab.module.css';

/**
 * Why a report can't be validated yet: a rejected QC run for one of its analytes on the
 * analyzer it came from (ADR 0039). Says what to do: run QC again, or ask for an override.
 */
export function QcHoldNotice({ holds }: { holds: readonly QcHoldView[] }) {
  if (holds.length === 0) return null;
  return (
    <Notice tone="error">
      <span>
        QC holds these results. Run QC again and get an acceptable run, or ask the lab manager for
        an override, before validating.
      </span>
      <ul className={styles.list}>
        {holds.map((hold) => (
          <li key={`${hold.analyte.id}-${hold.analyzer?.id ?? 'none'}`}>
            {`${hold.analyte.name} on ${hold.analyzer?.name ?? 'no analyzer (by hand)'}: `}
            {hold.runs.map((run, i) => (
              <span key={run.id}>
                {i === 0 ? '' : ', '}
                <Link to="/lab/qc/$targetId" params={{ targetId: run.targetId }}>
                  {`${run.levelLabel}, lot ${run.lotNumber}, rejected ${formatInstant(run.runAt)}`}
                </Link>
              </span>
            ))}
          </li>
        ))}
      </ul>
    </Notice>
  );
}
